<script>
export default {
  name: 'pages'
}
</script>

<template>
  <router-view :key="$route.name + '-' + $route.params.articleSlug"></router-view>
</template>



// WEBPACK FOOTER //
// src/components/pages.vue